import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-2853048a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "mdm-l-logo"
}, null, -1))

import { computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

import { EnterpriseSchema } from '../generated/sdk'


export default /*#__PURE__*/_defineComponent({
  __name: 'MdmNavBar',
  setup(__props) {

const store = useStore()
const router = useRouter()

const menu = [
  ['Home', '/', 'home'],
  ['Policies', '/policies', 'settings'],
  ['Devices', '/devices', 'devices'],
  ['Switch devices', '/switch-devices', 'sync_alt'],
  ['Zero touch', '/zero-touch', 'contactless'],
]

const enterprise = computed<EnterpriseSchema>(() => store.state.app.enterprise)

function logout() {
  store.commit('setApiKey', null)
  router.push('/login')
}

return (_ctx: any,_cache: any) => {
  const _component_NavBarItem = _resolveComponent("NavBarItem")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_NavBar = _resolveComponent("NavBar")!

  return (_openBlock(), _createBlock(_component_NavBar, { class: "mdm-l-navbar" }, {
    "navbar-header": _withCtx(() => [
      _createVNode(_component_RouterLink, {
        to: "/enterprise",
        class: "mdm-l-router-link"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_NavBarItem, {
            text: enterprise.value?.enterpriseDisplayName,
            important: ""
          }, {
            icon: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }, 8, ["text"])
        ]),
        _: 1
      })
    ]),
    "navbar-footer": _withCtx(() => [
      _createVNode(_component_NavBarItem, {
        text: "Logout",
        icon: "logout",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (logout()))
      })
    ]),
    default: _withCtx(() => [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menu, (item) => {
        return _createVNode(_component_RouterLink, {
          key: item[1],
          to: { path: item[1] },
          class: "mdm-l-router-link"
        }, {
          default: _withCtx((link) => [
            _createVNode(_component_NavBarItem, {
              text: item[0],
              icon: item[2],
              active: link.isActive
            }, null, 8, ["text", "icon", "active"])
          ]),
          _: 2
        }, 1032, ["to"])
      }), 64))
    ]),
    _: 1
  }))
}
}

})